import { Center, Bounds } from "@react-three/drei";
import { PartModel } from "./PartModel";

interface ModelViewerProps {
  parts: {
    base: string;
    partA: string;
    partB: string;
    orings: string;
  };
  activeParts: string[];
  activeColors: {
    AB: string;
    ORINGS: string;
  };
  onReady?: () => void;
}

export const ModelViewer: React.FC<ModelViewerProps> = ({
  parts,
  activeParts,
  activeColors,
  onReady,
}) => {
  return (
    <Center>
      <Bounds fit clip margin={1.2}>
        {/* BASE – always visible */}
       <PartModel
  path="/models/base.glb"
  isBase
/>

        {/* PART A */}
        <PartModel
          path={parts.partA}
          visible={activeParts.includes("V4A")}
          color={activeColors.AB}
        />

        {/* PART B */}
        <PartModel
          path={parts.partB}
          visible={activeParts.includes("V4B")}
          color={activeColors.AB}
        />

        {/* O-RINGS */}
        <PartModel
          path={parts.orings}
          visible={activeParts.includes("V4_Orings")}
          color={activeColors.ORINGS}
        />
      </Bounds>
    </Center>
  );
};
